<script>
    import { createEventDispatcher } from 'svelte';
    import { t } from "../../i18n";


    let input;
    let dispatch = createEventDispatcher();

    var inputFile;

    let send = () => {
        if(input.value) dispatch('send', input.value);
        input.value='';
    };

    let onFileUpload = function(){
        inputFile.click();
    };


    let files;
    $: if(files) dispatch('files', files);

</script>

<form class="d-flex align-items-center" on:submit|preventDefault={send}>
    <input type="file" bind:files bind:this={inputFile} style="display:none;" multiple="multiple">
    <i class="bx bx-paperclip ml-1 cursor-pointer" on:click={onFileUpload}></i>
    <input type="text" class="form-control widget-chat-message mx-75" placeholder={$t('chat.placeholder')} bind:this={input}>
    <button type="submit" class="btn btn-primary glow chat-fake-send" ><i class="bx bx-paper-plane"></i></button>
</form>